import { render, staticRenderFns } from "./VInputV2.vue?vue&type=template&id=adee4e10&scoped=true&"
import script from "./VInputV2.vue?vue&type=script&lang=js&"
export * from "./VInputV2.vue?vue&type=script&lang=js&"
import style0 from "./VInputV2.vue?vue&type=style&index=0&id=adee4e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adee4e10",
  null
  
)

export default component.exports